import React from "react";
import { cn } from "../../lib/cn";

/** Canonical field styling, extracted from BatchTrackModal so every control matches. */
export const inputCls =
  "w-full bg-surface-2 border border-border rounded-[11px] px-[15px] py-[13px] text-body font-sans text-[14.5px] outline-none transition-[border-color,box-shadow] duration-150 placeholder:text-faint focus:border-cyan/60 focus:shadow-[0_0_0_3px_rgba(39,182,203,.14)]";

const errorCls = "border-danger focus:border-danger focus:shadow-[0_0_0_3px_rgba(248,113,113,.16)]";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: boolean;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, error, ...props }, ref) => (
    <input ref={ref} className={cn(inputCls, error && errorCls, className)} {...props} />
  ),
);
Input.displayName = "Input";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, error, rows = 4, ...props }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(inputCls, "resize-y leading-[1.5]", error && errorCls, className)}
      {...props}
    />
  ),
);
Textarea.displayName = "Textarea";
